"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchFreeCourse = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var launchFreeCourse = function () {
    var eventData = {
        event: analytics_layer_1.ButtonInteractionEventNames.LaunchFreeCourse,
        eventInfo: analytics_layer_1.ButtonInteractionEventNames.LaunchFreeCourse,
    };
    return eventData;
};
exports.launchFreeCourse = launchFreeCourse;
